import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';
import { parseEnum } from '@/utils';


@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class Desire4Tekerlekli extends Vue
{
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;

  product: ProductDefinition;

  seletedFoot: string = DesireFoot.Krom;
  seletedKolcakYaziSehpasi: string = DesireKolcak.CiftKolcakliYaziSehpali;



  defHideObjects = [
    '_yyy',
  ];

  defShowObjects = [
    'desire_4tekerlekli_ayak_krom_yyy',
    'xxx_desire_govde_yyy',
    'desire_ince_demir_krom_yyy',
    'xxx_desire_govde_demiri_krom_yyy',
    'desire_duz_kolcak_pedi_sol_yyy',
    'desire_duz_kolcak_demiri_sol_krom_yyy',
    'desire_yazi_tahtasi_yyy',
    'desire_yazi_tahtasi_demiri_krom_yyy',
    'desire_duz_kolcak_pedi_sag_yyy',
    'desire_duz_kolcak_demiri_sag_krom_yyy',
  ];


  availableAnimations: AnimationDefinition[] = [];


  async created()
  {
    this.product = Store.getProductById('desire_dorttekerlekli');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes, ['order'], ['asc']);
    this.availableAnimations = this.product.animations as any;
    this.availableAnimationsChanged();

    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });


    if (Store.state.selection)
    {
      Store.state.selection.parts.forEach((element) =>
      {
        this.colorChanged(element.color, element.palette, element.id);
      });

      this.seletedFoot = Store.state.selection.foot;
      this.seletedKolcakYaziSehpasi = Store.state.selection.kolcak;
      await this.changeFoot(Store.state.selection.foot);

    } else
    {
      await this.applyDefaultSelection();
    }

  }


  availableAnimationsChanged()
  {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }



  mounted()
  {
    // this.configuratorService = Store.state.configuratorService;

  }

  async applyDefaultSelection()
  {
    const selection = new DesireSelection();
    selection.parts = [];

    selection.foot = DesireFoot.Krom;
    selection.kolcak = DesireKolcak.CiftKolcakliYaziSehpali;

    this.product.defaults.parts.forEach((element) =>
    {
      this.colorChanged(element.color, element.palette, element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.palette = element.palette;
      part.name = element.name;
      selection.parts.push(part);
    });

    Store.state.selection = selection;
    await this.changeFoot(DesireFoot.Krom);
    await this.changeKolcakYaziSehpasi(DesireKolcak.CiftKolcakliYaziSehpali);

  }

  async changeKolcakYaziSehpasi(kolcak: DesireKolcak)
  {
    await this._configuratorService.hideObjects({ objects: ['_yyy'], operator: FilterOperators.Contains });

    if (this.seletedFoot === DesireFoot.Krom)
    {
      await this._configuratorService.showObjects({ objects: ['desire_4tekerlekli_ayak_krom_yyy', 'xxx_desire_govde_yyy', 'xxx_desire_govde_demiri_krom_yyy'], operator: FilterOperators.Contains });

      if (kolcak === DesireKolcak.Kolcaksiz)
      {
        await this._configuratorService.showObjects({ objects: ['desire_kalin_demir_krom_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.kolcak = DesireKolcak.Kolcaksiz;
        this.seletedKolcakYaziSehpasi = DesireKolcak.Kolcaksiz;

      }
      else if (kolcak === DesireKolcak.Kolcakli)
      {
        await this._configuratorService.showObjects({ objects: ['desire_kalin_demir_krom_yyy', 'desire_cikinti_kolcak_pedi_sag_yyy', 'desire_cikinti_kolcak_pedi_sol_yyy', 'desire_cikinti_kolcak_demiri_sag_krom_yyy', 'desire_cikinti_kolcak_demiri_sol_krom_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.kolcak = DesireKolcak.Kolcakli;
        this.seletedKolcakYaziSehpasi = DesireKolcak.Kolcakli;
      }
      else if (kolcak === DesireKolcak.TekKolcakliYaziSehpali)
      {
        await this._configuratorService.showObjects({ objects: ['desire_ince_demir_krom_yyy', 'desire_duz_kolcak_pedi_sol_yyy', 'desire_duz_kolcak_demiri_sol_krom_yyy', 'desire_yazi_tahtasi_yyy', 'desire_yazi_tahtasi_demiri_krom_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.kolcak = DesireKolcak.TekKolcakliYaziSehpali;
        this.seletedKolcakYaziSehpasi = DesireKolcak.TekKolcakliYaziSehpali;
      }
      else // kolcak === DesireKolcak.CiftKolcakliYaziSehpali
      {
        await this._configuratorService.showObjects({ objects: ['desire_ince_demir_krom_yyy', 'desire_duz_kolcak_pedi_sol_yyy', 'desire_duz_kolcak_demiri_sol_krom_yyy', 'desire_yazi_tahtasi_yyy', 'desire_yazi_tahtasi_demiri_krom_yyy', 'desire_duz_kolcak_pedi_sag_yyy', 'desire_duz_kolcak_demiri_sag_krom_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.kolcak = DesireKolcak.CiftKolcakliYaziSehpali;
        this.seletedKolcakYaziSehpasi = DesireKolcak.CiftKolcakliYaziSehpali;
      }

    }

    if (this.seletedFoot === DesireFoot.Boyali)
    {
      await this._configuratorService.showObjects({ objects: ['desire_4tekerlekli_ayak_boyali_yyy', 'xxx_desire_govde_yyy', 'xxx_desire_govde_demiri_boyali_yyy'], operator: FilterOperators.Contains });

      if (kolcak === DesireKolcak.Kolcaksiz)
      {
        await this._configuratorService.showObjects({ objects: ['desire_kalin_demir_boyali_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.kolcak = DesireKolcak.Kolcaksiz;
        this.seletedKolcakYaziSehpasi = DesireKolcak.Kolcaksiz;
      }
      else if (kolcak === DesireKolcak.Kolcakli)
      {
        await this._configuratorService.showObjects({ objects: ['desire_kalin_demir_boyali_yyy', 'desire_cikinti_kolcak_pedi_sag_yyy', 'desire_cikinti_kolcak_pedi_sol_yyy', 'desire_cikinti_kolcak_demiri_sag_boyali_yyy', 'desire_cikinti_kolcak_demiri_sol_boyali_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.kolcak = DesireKolcak.Kolcakli;
        this.seletedKolcakYaziSehpasi = DesireKolcak.Kolcakli;
      }
      else if (kolcak === DesireKolcak.TekKolcakliYaziSehpali)
      {
        await this._configuratorService.showObjects({ objects: ['desire_ince_demir_boyali_yyy', 'desire_duz_kolcak_pedi_sol_yyy', 'desire_duz_kolcak_demiri_sol_boyali_yyy', 'desire_yazi_tahtasi_yyy', 'desire_yazi_tahtasi_demiri_boyali_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.kolcak = DesireKolcak.TekKolcakliYaziSehpali;
        this.seletedKolcakYaziSehpasi = DesireKolcak.TekKolcakliYaziSehpali;
      }
      else // this.seletedKolcakYaziSehpasi === DesireKolcak.CiftKolcakliYaziSehpali
      {
        await this._configuratorService.showObjects({ objects: ['desire_ince_demir_boyali_yyy', 'desire_duz_kolcak_pedi_sol_yyy', 'desire_duz_kolcak_demiri_sol_boyali_yyy', 'desire_yazi_tahtasi_yyy', 'desire_yazi_tahtasi_demiri_boyali_yyy', 'desire_duz_kolcak_pedi_sag_yyy', 'desire_duz_kolcak_demiri_sag_boyali_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.kolcak = DesireKolcak.CiftKolcakliYaziSehpali;
        this.seletedKolcakYaziSehpasi = DesireKolcak.CiftKolcakliYaziSehpali;
      }
    }
  }

  async changeFoot(foot: DesireFoot)
  {
    await this._configuratorService.hideObjects({ objects: ['_yyy'], operator: FilterOperators.Contains });

    if (foot === DesireFoot.Krom)
    {
      await this._configuratorService.showObjects({ objects: ['desire_4tekerlekli_ayak_krom_yyy', 'xxx_desire_govde_yyy', 'xxx_desire_govde_demiri_krom_yyy'], operator: FilterOperators.Contains });

      if (this.seletedKolcakYaziSehpasi === DesireKolcak.Kolcaksiz)
      {
        await this._configuratorService.showObjects({ objects: ['desire_kalin_demir_krom_yyy'], operator: FilterOperators.Contains });
      }
      else if (this.seletedKolcakYaziSehpasi === DesireKolcak.Kolcakli)
      {
        await this._configuratorService.showObjects({ objects: ['desire_kalin_demir_krom_yyy', 'desire_cikinti_kolcak_pedi_sag_yyy', 'desire_cikinti_kolcak_pedi_sol_yyy', 'desire_cikinti_kolcak_demiri_sag_krom_yyy', 'desire_cikinti_kolcak_demiri_sol_krom_yyy'], operator: FilterOperators.Contains });
      }
      else if (this.seletedKolcakYaziSehpasi === DesireKolcak.TekKolcakliYaziSehpali)
      {
        await this._configuratorService.showObjects({ objects: ['desire_ince_demir_krom_yyy', 'desire_duz_kolcak_pedi_sol_yyy', 'desire_duz_kolcak_demiri_sol_krom_yyy', 'desire_yazi_tahtasi_yyy', 'desire_yazi_tahtasi_demiri_krom_yyy'], operator: FilterOperators.Contains });
      }
      else // this.seletedKolcakYaziSehpasi === DesireKolcak.CiftKolcakliYaziSehpali
      {
        await this._configuratorService.showObjects({ objects: ['desire_ince_demir_krom_yyy', 'desire_duz_kolcak_pedi_sol_yyy', 'desire_duz_kolcak_demiri_sol_krom_yyy', 'desire_yazi_tahtasi_yyy', 'desire_yazi_tahtasi_demiri_krom_yyy', 'desire_duz_kolcak_pedi_sag_yyy', 'desire_duz_kolcak_demiri_sag_krom_yyy'], operator: FilterOperators.Contains });
      }

      Store.state.selection.foot = DesireFoot.Krom;
      this.seletedFoot = DesireFoot.Krom;

    }

    if (foot === DesireFoot.Boyali)
    {
      await this._configuratorService.showObjects({ objects: ['desire_4tekerlekli_ayak_boyali_yyy', 'xxx_desire_govde_yyy', 'xxx_desire_govde_demiri_boyali_yyy'], operator: FilterOperators.Contains });

      if (this.seletedKolcakYaziSehpasi === DesireKolcak.Kolcaksiz)
      {
        await this._configuratorService.showObjects({ objects: ['desire_kalin_demir_boyali_yyy'], operator: FilterOperators.Contains });
      }
      else if (this.seletedKolcakYaziSehpasi === DesireKolcak.Kolcakli)
      {
        await this._configuratorService.showObjects({ objects: ['desire_kalin_demir_boyali_yyy', 'desire_cikinti_kolcak_pedi_sag_yyy', 'desire_cikinti_kolcak_pedi_sol_yyy', 'desire_cikinti_kolcak_demiri_sag_boyali_yyy', 'desire_cikinti_kolcak_demiri_sol_boyali_yyy'], operator: FilterOperators.Contains });
      }
      else if (this.seletedKolcakYaziSehpasi === DesireKolcak.TekKolcakliYaziSehpali)
      {
        await this._configuratorService.showObjects({ objects: ['desire_ince_demir_boyali_yyy', 'desire_duz_kolcak_pedi_sol_yyy', 'desire_duz_kolcak_demiri_sol_boyali_yyy', 'desire_yazi_tahtasi_yyy', 'desire_yazi_tahtasi_demiri_boyali_yyy'], operator: FilterOperators.Contains });
      }
      else // this.seletedKolcakYaziSehpasi === DesireKolcak.CiftKolcakliYaziSehpali
      {
        await this._configuratorService.showObjects({ objects: ['desire_ince_demir_boyali_yyy', 'desire_duz_kolcak_pedi_sol_yyy', 'desire_duz_kolcak_demiri_sol_boyali_yyy', 'desire_yazi_tahtasi_yyy', 'desire_yazi_tahtasi_demiri_boyali_yyy', 'desire_duz_kolcak_pedi_sag_yyy', 'desire_duz_kolcak_demiri_sag_boyali_yyy'], operator: FilterOperators.Contains });
      }

      Store.state.selection.foot = DesireFoot.Boyali;
      this.seletedFoot = DesireFoot.Boyali;

    }
  }

  async colorChanged(color: any, palette: any, part: any)
  {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

}


export class DesireSelection
{
  parts: PartSelection[];
  foot: DesireFoot;
  kolcak: DesireKolcak;
}
export class PartSelection
{
  id: string;
  palette: string;
  color: string;
  name: string;
}


enum DesireFoot
{
  Krom = 'krom',
  Boyali = 'boyali',

}

enum DesireKolcak
{
  Kolcaksiz = 'kolcaksiz',
  Kolcakli = 'kolcakli',
  TekKolcakliYaziSehpali = 'tekkolcakliyazisehpali',
  CiftKolcakliYaziSehpali = 'ciftkolcakliyazisehpali',

}



// WEBPACK FOOTER //
// ./src/components/families/desire/Desire4Tekerlekli.ts